import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemOverview } from './components/SystemOverview';
import { InsideCarousel } from './components/InsideCarousel';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { WhyDifferent } from './components/WhyDifferent';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
type MetaWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
const META_PIXEL_ID = '1367632915547845';
export function App() {
  useEffect(() => {
    const w = window as MetaWindow;
    try {
      if (!w.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as MetaPixel;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        w.fbq = pixel;
        w._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-ink antialiased" data-id="element-0" data-mp="st2g8bersjfk">
      <noscript data-id="element-1" data-mp="356sn718lka4">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1367632915547845&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="34napqbl6vw3" />
      </noscript>
      <main data-id="element-3" data-mp="85ukfuxai55e">
        <Hero data-id="element-4" data-mp="85bb32lpgp2z" />
        <PainPoints data-id="element-5" data-mp="86mcivrohkqx" />
        <SolutionReveal data-id="element-6" data-mp="86cmx9ajpflr" />
        <SystemOverview data-id="element-7" data-mp="83qdf443gq0w" />
        <InsideCarousel data-id="element-8" data-mp="3gkv1zuywlvev" />
        <TomosSection data-id="element-9" data-mp="3gm647qcpav3v" />
        <BonusSection data-id="element-10" data-mp="3glo2ie79rook" />
        <PricingSection data-id="element-11" data-mp="3bmbevr8kqdkx" />
        <WhyDifferent data-id="element-12" data-mp="3bn2y02kziiub" />
        <Guarantee data-id="element-13" data-mp="3bnmf5h2t937a" />
        <FAQ data-id="element-14" data-mp="3bo4l55f9yvse" />
        <FinalCTA data-id="element-15" data-mp="3bkgq21u6m1bk" />
      </main>
      <Footer data-id="element-16" data-mp="3qbpql5zmh73h" />
      <PurchaseNotifications data-id="element-17" data-mp="3qc966g1svjec" />
    </div>;
}